import { writable, get } from 'svelte/store';

const model = () => {
	let formData = window.model;
	if (formData.registrationNumber && formData.registrationNumber.indexOf("[[DATESTRING]]") > -1) {
		let today = new Date();

		formData.registrationNumber = formData.registrationNumber
			.replace("[[DATESTRING]]", `${today.getFullYear().toString()}${(today.getMonth() + 1).toString().padStart(2, "0")}${today.getDate().toString().padStart(2, "0")}`);
	}

	let store = writable(formData || {});

	async function saveModelAsync(url) {
		let data = get(store);

		let options = {
			method: "POST",
			headers: {
				"Content-type": "application/json",
			},
			body: JSON.stringify(data)
		};

		let response = await fetch(`${url}`, options);
		if (!response.ok) {
			let data = await response.json();

			return { ...data };
		}

		return {
			success: true
		};
	}

	return {
		...store,
		saveModelAsync,
	};
}

export default model();
